import calls from '@/backend/api-calls'

const state = () => ({
  tasks: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    workstation_id: null
  }
})

// getters
const getters = {
  ids: state => {
    return state.queue.map(d => d.id);
  }
}

// actions
const actions = {
  getWorkstationTasks: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.workstationQueues.get(parameters)
        .then(resp => {
          commit("setWorkstationTasks", resp.data);
          commit("sortTasks");
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addWorkstationTask({commit, state}, data) {
    return new Promise((resolve, reject) => {
      calls.workstationQueues.post(data)
        .then(resp => {
          if (
            !state.filters.workstation_id || 
            state.filters.workstation_id == resp.data.workstation_id
          ) {
            commit("insertWorkstationTask", resp.data);
          }
          
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Task successfully updated'
          }, { root: true });
          
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateTask: ({commit}, { taskId, data }) => {
    return new Promise((resolve, reject) => {
      calls.workstationQueue.put(taskId, data).then(
        resp => {
          commit("insertUpdatedWorkstationTask", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Task successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteWorkstationTask: ({commit}, queueId) => {
    return new Promise((resolve, reject) => {
      calls.workstationQueue.delete(queueId).then(
        resp => {
          commit("removeWorkstationTask", queueId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Task successfully unassigned from workstation'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setWorkstationTasks(state, data) {
    state.pagination = data.pagination;
    state.tasks = data.results;
  },
  insertWorkstationTask(state, data) {
    state.tasks.push(data);
  },
  insertUpdatedWorkstationTask(state, data) {
    state.tasks.forEach((task, i) => {
      if (task.id == data.id) {
        state.tasks.splice(i, 1, data);
      }
    })
  },
  removeTask(state, taskId) {
    state.tasks.forEach((task, i) => {
      if (task.id == taskId) {
        state.tasks.splice(i, 1);
      }
      const index = state.selected.indexOf(taskId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  sortTasks(state) {
    state.tasks.sort((a, b) => a.workstation_order - b.workstation_order);
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}